<template>
<label v-if="label" for="password" class="form-label">{{ label }}</label>
    <label v-else-if="label === null" for="password" class="form-label">{{ $t('password.label') }}</label>
    <div class="input-group input-group-merge">
        <input 
            :id="id" 
            class="form-control" 
            ref="passwordInput" 
            v-model="password" 
            @input="updatePassword" 
            :type="visible ? 'text' : 'password'" 
            :required="required" 
            :readonly="readonly" 
            :maxlength="maxlength"
            :placeholder="hintText ?? $t('password.placeholder')"
            :tabindex="tabindex"
            :autocomplete="autocomplete"
            @focus="isFocused = true"
            @blur="isFocused = false"
        >
        <div :class="['input-group-text', {'show-password': visible }]">
            <span class="password-eye" @click="showPassword"></span>
        </div>
    </div>
    <div v-if="displayHints && isFocused" class="mt-1 space-y-1">
        <CheckListItem :text="$t('password.hints.minLength')" :is-valid="hasMinLength" />
        <CheckListItem :text="$t('password.hints.uppercase')" :is-valid="hasUppercase" />
        <CheckListItem :text="$t('password.hints.lowercase')" :is-valid="hasLowercase" />
        <CheckListItem :text="$t('password.hints.digit')" :is-valid="hasDigit" />
        <CheckListItem :text="$t('password.hints.special')" :is-valid="hasSpecial" />
    </div>    
</template>

<script>
import CheckListItem from '@/components/checkListItem';

export default {
    name: 'PasswordComponent',
    components: { CheckListItem },
    props: {
        id: {
            type: String,
            default: 'password'
        },
        required: {
            type: Boolean,
            default: true
        },
        readonly: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: null
        },
        modelValue: {
            type: String,
            required: true
        },
        autocomplete: {
            type: String,
            default: 'new-password'
        },
        tabindex: {
            type: String,
            default: '-1'
        },
        displayHints: {
            type: Boolean,
            default: false
        },
        hintText: {
            type: String,
            default: null
        },
        maxlength: {
            type: [Number, String],
            default: 64
        }
    },
    data() {
        return {
            password: this.modelValue,
            visible: false,
            error: "",
            isFocused: false,
        }
    },
    computed: {
        hasMinLength() {
            return this.password.length >= 8;
        },
        hasUppercase() {
            return /[A-Z]/.test(this.password);
        },
        hasLowercase() {
            return /[a-z]/.test(this.password);
        },
        hasDigit() {
            return /\d/.test(this.password);
        },
        hasSpecial() {
            return /[@$!%*?&]/.test(this.password);
        }
    },    
    methods : {
        showPassword() {
            this.visible = !this.visible;
        },
        setVisible(visible) {
            this.visible = visible;
        },
        updatePassword() {
            this.$refs.passwordInput.setCustomValidity('');
            this.$emit('update:modelValue', this.password);
        }
    },
    watch: {
        modelValue: {
            handler(newValue) {
                this.password = newValue;
            },
            deep: true
        }
    },     
};
</script>
